
export interface Project {
    id: string;
    slug: string; // url path like /vgfoods
    title: string;
    location: string;
    category: {
        text: string;
        style?: React.CSSProperties;
        className?: string; // For text color e.g. "text-white"
    };
    shortDescription: string; // for the modal
    fullDescription: string; // for the details page
    techStack: string[];
    challenge: string;
    solution: string;
    results: string;
    mediaType: 'image' | 'video';
    thumbnailSrc: string; // For landing page card
    modalImageSrc: string; // For modal
    detailImageSrc: string; // For details page main image
    galleryImages: string[]; // For gallery
    websiteLink?: string; // External link
    isDarkTheme?: boolean; // For landing card
    isFullWidth?: boolean; // For landing card
    textColor?: string;
    disableZoom?: boolean;
    align?: 'left' | 'right';
    titleClasses?: string;
    mediaStyle?: React.CSSProperties;
    disableCrop?: boolean;
}

export const projects: Project[] = [
    {
        id: 'vgfoods',
        slug: '/vgfoods',
        title: 'VGFoodsUK',
        location: 'United Kingdom',
        category: {
            text: 'SEO & PWA',
            style: { color: "#FFF" }
        },
        shortDescription: "Entire website + SEO + PWA using Supabase and PostgreSQL.",
        fullDescription: "We orchestrated the complete digital transformation for VGFoodsUK. This included building a high-performance website from scratch, implementing a Progressive Web App (PWA) for native-like capabilities, and executing a dominant SEO strategy. usage of Supabase and PostgreSQL to handle complex data requirements seamlessly.",
        techStack: ["TypeScript", "Supabase", "PostgreSQL", "PWA", "SEO", "React"],
        challenge: "To deliver a unified, high-speed ecosystem that could handle large inventory data while ensuring top-ranking organic search results.",
        solution: "A robust PWA architecture was chosen for speed and offline access. The backend was powered by Supabase and PostgreSQL for reliability. A 360-degree SEO implementation ensured maximum visibility.",
        results: "Achieved localized dominance in search results, rapidly increasing user acquisition and engagement figures.",
        mediaType: 'image',
        thumbnailSrc: "https://res.cloudinary.com/dscurx1gc/image/upload/v1769540102/VGFoods_mac_image_ej1j8o.png",
        modalImageSrc: "https://res.cloudinary.com/dscurx1gc/image/upload/v1769540102/VGFoods_mac_image_ej1j8o.png",
        detailImageSrc: "https://res.cloudinary.com/dscurx1gc/image/upload/v1769540102/VGFoods_mac_image_ej1j8o.png",
        galleryImages: [
            "/vgfoods/vg_features.png",
            "/vgfoods/vg_insights.png"
        ],
        websiteLink: "https://vgfoodsuk.com/",
        isFullWidth: true,
        isDarkTheme: false,
        align: 'right',
        textColor: 'text-white'
    },
    {
        id: 'worldawaits',
        slug: '/worldawaits',
        title: 'The World',
        location: 'Awaits',
        category: {
            text: 'Travel & Web',
            style: { color: "#FAF9F6" }
        },
        shortDescription: "Immersive travel experience website.",
        fullDescription: "The World Awaits is a travel portal that uses video backgrounds and immersive storytelling to inspire wanderlust.",
        techStack: ["React", "GSAP", "Three.js"],
        challenge: "Balancing high-quality video content with site performance.",
        solution: "Optimized video delivery and lazy loading techniques.",
        results: "Award-winning design mentions and high user dwell time.",
        mediaType: 'video',
        thumbnailSrc: "/travel_web_video.mp4",
        modalImageSrc: "https://res.cloudinary.com/dscurx1gc/image/upload/v1769541448/travel_web_video_kegvsm.jpg", // Needs an image for modal ideally, falling back if needed or using video? User said "pop up card with a image"
        detailImageSrc: "https://res.cloudinary.com/dscurx1gc/image/upload/v1769541448/travel_web_video_kegvsm.jpg",
        galleryImages: [],
        isFullWidth: true,
        isDarkTheme: false,
        textColor: 'text-white',
        disableZoom: true,
        align: 'right',
        titleClasses: 'text-2xl sm:text-3xl lg:text-4xl',
        mediaStyle: { objectFit: 'cover', objectPosition: 'center', transform: 'scale(0.85)' }
    },
    {
        id: 'koffeestation',
        slug: '/koffeestation',
        title: 'Koffee Station',
        location: 'Hosur, TamilNadu',
        category: {
            text: 'Cafe',
            style: { color: "#FAF9F6" }
        },
        shortDescription: "A premium coffee destination featuring rapid content delivery and an optimized digital presence.",
        fullDescription: "Koffee Station is a premium cafe in Hosur dedicated to providing a unique coffee experience. The platform was designed to visually communicate the warmth and quality of their diverse menu of coffee blends and snacks, integrating seamless communication channels such as direct WhatsApp routing.",
        techStack: ["React", "TypeScript", "Tailwind CSS", "SEO", "Cloudinary"],
        challenge: "Koffee Station required an inviting digital storefront to highlight their premium coffee blends. The main hurdle was creating a visually stunning, asset-heavy interface that remained highly performant and easily discoverable by local coffee enthusiasts.",
        solution: "Constructed a modern, component-driven website using React and TypeScript. We crafted a beautiful, fluid UI utilizing Tailwind CSS, while all multimedia assets were seamlessly managed via Cloudinary for rapid delivery. Deep SEO optimization was applied natively to improve their local ranking.",
        results: "Successfully established a distinct digital brand identity. The optimized performance and improved search rankings significantly elevated direct customer engagement and inquiries.",
        mediaType: 'image',
        thumbnailSrc: "https://res.cloudinary.com/dwxijtvom/image/upload/v1774358622/ywdudzbh3tp0chbqxzdb.png",
        modalImageSrc: "https://res.cloudinary.com/dwxijtvom/image/upload/v1774358622/ywdudzbh3tp0chbqxzdb.png",
        detailImageSrc: "https://res.cloudinary.com/dwxijtvom/image/upload/v1774358622/ywdudzbh3tp0chbqxzdb.png",
        galleryImages: [],
        websiteLink: "https://koffeestation.in/",
        isDarkTheme: false,
        textColor: 'text-white'
    }
];
